 <!-- ======= Footer ======= -->
 <footer id="footer">
    <div class="footer-top padding-bottom-10">
        <div class="container">
            <div class="pad_15">
            <div class="row">

                <div class="col-lg-4 col-md-6">
                    <div class="footer-info">
                        <img src="../../assets/img/rms-logo-white.svg">
                        <p class="pb-3">Samyak Provides End to End Remote monitoring system from electronics to web
                            and mobile application.</p>

                    </div>
                </div>

                <div class="col-lg-2 col-md-1">
                </div>

                <div class="col-lg-2 col-md-2 col-6 footer-links">
                    <h4>Company</h4>
                    <ul>
                        <li> <a href="about-us.html">About</a></li>
                        <li><a href="Services.html">Services</a></li>
                        <li> <a href="project.html">Project</a></li>
                        <li><a href="blog.html">Blog</a></li>

                    </ul>
                </div>
                <!-- <div class="col-lg-2 col-md-6 footer-links">
                    <h4>Region</h4>
                    <ul>
                        <li> <a href="#">India</a></li>
                        <li><a href="#">England</a></li>
                        <li> <a href="#">Chaina</a></li>
                        <li><a href="#">Canada</a></li>

                    </ul>
                </div> -->
                <div class="col-lg-2 col-md-3 col-6 footer-links">
                    <h4>Help</h4>
                    <ul>
                        <li> <a href="#">Help center</a></li>
                        <li><a href="#">Contact support</a></li>
                        <li> <a href="#">Instructions</a></li>
                        <li><a href="#">How it works</a></li>

                    </ul>
                </div>
                <div class="col-lg-2 col-md-6 col-6 footer-links">
                    <div>
                    <h4>Contact Us</h4>
                   
                    <ul>
                        <li> <a href="#"><img src="../../assets/img/linkdin.svg" class="link-img-linkdin"></a>
                            <a href="#"><img src="../../assets/img/twitter.svg" class="link-img margin-left-5"></a>
                            <a href="#"><img src="../../assets/img/facebook.svg" class="link-img margin-left-5"></a>
                            <a href="#"><img src="../../assets/img/insta.svg" class="link-img margin-left-5"></a>
                            <a href="#"><img src="../../assets/img/youtube.svg" class="link-img margin-left-5"></a>
                        </li>
                    </ul>
                    </div>
                    

                    <!-- <p class="pb-3">Need to give reference of Samyak Infotech Pvt. Ltd. www.samyak.com, Samyak Instrumentation Pvt. Ltd. www.samyak.co.in</p> -->
                    
<div class="display_flex_footer">
    <div class="margin_right_30">
                    <p class="margin-0 font-white pt-3 margin-right-5"><a class="font-white d-flex" href="https://www.samyak.com/"><img
                                src="../../assets/img/website.svg"
                                class="link-img-linkdin margin-right-5 link-img">www.samyak.com</a>
                    </p>
                </div>
                <div>
                    <!-- <p class="pb-3">Need to give reference of Samyak Infotech Pvt. Ltd. www.samyak.com, Samyak Instrumentation Pvt. Ltd. www.samyak.co.in</p> -->
                    <p class="margin-0 font-white pt-3"><a class="font-white d-flex" href="https://samyak.co.in/"><img
                        src="../../assets/img/website.svg"
                        class="link-img-linkdin margin-right-5 link-img">www.samyak.co.in</a>
            </p>
                </div>
   
</div>
                </div>

                

            </div>
        </div>
        </div>
    </div>
    <div class="footer-bg">
        <p class="m-0">@ 2022. All right reserved Samyak Infotech Private Limited.</p>
    </div>
</footer>
<!-- End Footer -->